import React, { useLayoutEffect, useMemo } from 'react';

import { Fuse, printMissingConfigError, SiteConfigManager } from '@atlas/core';

import { loadScript } from 'common/utils';

const ApgLicense = ({ iconSize, iconStyle }) => {
  const apgId = SiteConfigManager.getConfig('config.config.license.apgId');
  const apgDomId = SiteConfigManager.getConfig('config.config.license.apgDomId', 'X41');

  if (!apgId) {
    printMissingConfigError('config.config.license.apgId');
  }

  useLayoutEffect(() => {
    const apgWindowObject = window[apgDomId.replaceAll('-', '_')];

    if (
      apgWindowObject &&
      typeof apgWindowObject === 'object' &&
      typeof apgWindowObject.init === 'function'
    ) {
      try {
        apgWindowObject.init();
      } catch (e) {
        console.error("Can't show apg license");
      }
    } else {
      (async () => {
        await loadScript(`https://${apgId}.snippet.antillephone.com/apg-seal.js`);
      })();
    }
  }, []);

  return useMemo(() => {
    const apgLicenseDomElement = document.querySelector(`#${apgDomId}`);

    if (!apgLicenseDomElement) {
      return (
        <div
          className="e-gaming-logo"
          data-apg-image-size={iconSize}
          data-apg-image-type="basic-small"
          data-apg-seal-id={apgId}
          id={apgDomId}
          style={iconStyle}
        />
      );
    }

    return (
      <div
        className="e-gaming-logo"
        dangerouslySetInnerHTML={{ __html: apgLicenseDomElement.innerHTML }}
      />
    );
  }, []);
};

const fallback = () => <div />;

export default function (props) {
  return (
    <Fuse fallback={fallback}>
      <ApgLicense {...props} />
    </Fuse>
  );
}
